import {StyledCard as CalendarCards, StyledName as ClubName, StyledDate as MatchDate, StyledCrest as ClubCrest, StyledTypePill} from '../../../Home/components/HomeCalendar/styled';
import { selectMenuCss } from '../../../../theme/selectStyles';
import styled from 'styled-components';
import { fontDisplay, fontUi } from '../../../../theme/typography';
export const Header = styled.header`
  grid-area: heading; display:flex;
  align-items:center; justify-content:space-between; gap:20px; flex-wrap:wrap;
  @media(min-width:1200px) {h1 {font-size:20px !important;margin:0;} p {display:none;} }
  h1 { ${fontDisplay}; font-size:28px; margin:0 0 6px; }
  @media(max-width:1199px) { gap:12px; h1 {font-size:22px;} p {display:none;} }
  p { ${fontUi}; font-size:14px; color:${({theme})=>theme.textFaint}; margin:0; }
`;
export const Actions = styled.div`
  display:flex; gap:12px; align-items:center; flex-wrap:wrap;
  > button { margin:0; height:48px !important; min-height:48px; box-sizing:border-box; }
  @media(max-width:1199px) { width:100%; gap:8px; > button:last-of-type {min-width:125px; padding:0 12px; font-size:12px;} }
  > button:last-of-type { min-width:160px; height:48px; padding:0 22px; background:${({theme})=>theme.success}; border-color:${({theme})=>theme.success}; color:#fff; font-size:14px; }
  @media(max-width:1199px) {> button:last-of-type {min-width:125px;padding:0 12px;font-size:12px;}}
`;
export const Delegate = styled.div`
  ${fontUi}; display:flex; align-items:center; gap:12px; padding:0 18px; height:48px; box-sizing:border-box;
  background:${({theme})=>theme.card}; border:1px solid ${({theme})=>theme.border}; border-radius:${({theme})=>theme.controlRadius};
  font-size:13px;
  @media(max-width:1199px) {flex:1; justify-content:space-between; padding:0 10px; gap:6px; font-size:11px;}
`;
export const Toolbar = styled.div`
  grid-area: controls; display:flex;
  @media(min-width:1200px) {
    flex-direction:column;justify-content:flex-start;gap:10px;
    align-self:stretch; min-height:0; max-height:100%; overflow-x:hidden; overflow-y:auto;
    overscroll-behavior:contain;
    .strategy-select__control {min-height:54px;padding:6px 10px;}
    > div {flex:none;width:100%;}
    ${Actions} {flex-direction:column;gap:8px;margin-top:4px; > button {width:100%;min-width:0;height:36px !important;min-height:36px;font-size:12px;padding:0 8px;}}
    ${Delegate} {width:100%;height:40px;padding:0 8px;gap:5px;font-size:10px;}
  }
 align-items:stretch; gap:10px; flex-wrap:wrap; min-width:0;
  background:${({theme})=>theme.card}; border:1px solid ${({theme})=>theme.border}; border-radius:${({theme})=>theme.cardRadius}; padding:12px;
  @media(max-width:1199px) {gap:6px; padding:8px;}
`;
export const Control = styled.div`
  ${fontUi}; display:flex; flex:1 1 110px; flex-direction:column; gap:5px; min-width:0; padding:0;
  border-radius:${({theme})=>theme.controlRadius};
  > span { font-size:11px; color:${({theme})=>theme.textFaint}; }
  .strategy-select__control { min-height:64px; padding:8px 12px; border:1px solid ${({theme})=>theme.borderSubtle}; border-radius:${({theme})=>theme.controlRadius}; background:transparent; box-shadow:none; cursor:pointer; }
  .strategy-select__control--is-focused { outline:2px solid ${({theme})=>theme.headerAccent}; outline-offset:3px; }
  ${selectMenuCss('strategy-select')}
  .strategy-select__menu { min-width:max(100%, 180px); width:max-content; }
  .strategy-select__value-container { padding:0; }
  .strategy-select__single-value { color:${({theme})=>theme.text}; width:100%; margin:0; }
  .strategy-select__indicator-separator { display:none; }
  .strategy-select__indicator { padding:4px; color:${({theme})=>theme.textFaint}; }
  .strategy-option { display:flex; align-items:center; gap:10px; font-size:14px; font-weight:600; }
  .strategy-option-copy { display:flex; flex-direction:column; gap:4px; }
  .strategy-option-copy small { font-size:11px; font-weight:400; color:${({theme})=>theme.textFaint}; }
  .strategy-option svg [fill]:not([fill="none"]) { fill:currentColor; }
  .strategy-option svg [stroke]:not([stroke="none"]) { stroke:currentColor; }
  .strategy-option svg g { opacity:1; }
  .strategy-option svg { width:30px; height:30px; flex-shrink:0; }
  /* Flip formation diagram only — not the chevron indicator. */
  &.formation-section .strategy-option > svg { transform:rotate(180deg); }
  &.formation-section .strategy-option > svg g { opacity:1; }
  &.formation-section .strategy-option > svg circle { fill:currentColor; }
  &.formation-section .style-filters {
    display:flex; gap:4px; padding:2px 2px 8px; margin:0 0 2px;
    border-bottom:1px solid ${({theme})=>theme.borderSubtle};
  }
  &.formation-section .style-filters button {
    flex:1; min-width:0; padding:5px 6px; border:1px solid ${({theme})=>theme.borderSubtle};
    border-radius:${({theme})=>theme.controlRadius}; background:transparent;
    color:${({theme})=>theme.textMuted}; font:inherit; font-size:10px; font-weight:600;
    line-height:1; cursor:pointer;
  }
  &.formation-section .style-filters button:hover {
    color:${({theme})=>theme.text}; background:${({theme})=>theme.hover};
  }
  &.formation-section .style-filters button[aria-pressed='true'] {
    color:${({theme})=>theme.card}; background:${({theme})=>theme.text}; border-color:${({theme})=>theme.text};
  }
  &.formation-section .style-beats {
    margin: 0;
    padding: 4px 10px 6px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.35;
    color: ${({ theme }) => theme.textFaint};
  }
  @media(max-width:1199px) {
    flex:1 1 0;
    .strategy-select__control {padding:4px; min-height:58px;}
    .strategy-option {gap:5px; font-size:11px;}
    .strategy-option svg {width:20px; height:20px;}
    .strategy-option-copy small {font-size:9px;}
    .strategy-select__indicator {padding:0;}
    .strategy-select__indicator svg {width:14px;}
    .strategy-select__menu {min-width:max(100%,140px);}
  }
  select { ${fontUi}; font-size:14px; font-weight:600; width:100%; min-width:0; border:0; color:${({theme})=>theme.text}; background:${({theme})=>theme.card}; cursor:pointer; }
`;
export const Pitch = styled.div`
  grid-area:pitch; position:relative; min-width:0;
  &.football-container { box-sizing:border-box; width:100%; max-width:none; height:var(--pitch-height, 480px); min-height:0; max-height:none; margin:0; padding:0; border:1px solid ${({theme})=>theme.border}; border-radius:${({theme})=>theme.cardRadius}; }
  @media(min-width:1200px) {&.football-container {width:calc(var(--pitch-height,480px) * 1.18);max-width:100%;justify-self:center;} .playing-field > div > div {scale:var(--pitch-scale, .8);} }
  background:repeating-linear-gradient(100deg,#187747 0,#187747 11%,#1e8049 11%,#1e8049 22%);
  > .pitch-art { position:absolute; inset:0; width:100%; height:100%; border-radius:inherit; overflow:hidden; pointer-events:none; display:none; object-fit:fill; }
  > .pitch-art--compact { display:block; }
  /* Mild inset so wings sit on the grass without compressing lane spacing. */
  > .playing-field { position:absolute; top:2%; left:4%; width:92%; height:96%; margin:0; display:grid; grid-template-columns:repeat(20,minmax(0,1fr)); grid-template-rows:repeat(21,minmax(0,1fr)); }
  > .playing-field.away { border-radius:inherit; }
  .sponsor { position:absolute; bottom:16px; left:18px; width:80px; z-index:1; }
  .sponsor img { width:100%; display:block; }
  /* Tablet / mid: compact art, aspect-locked and centred — wide enough that
     four-across lines are not crushed, without stretching full-bleed. */
  @media(max-width:1199px) {
    &.football-container {
      width:min(100%, 760px, calc(78vh * 1.18));
      height:auto;
      min-height:0;
      max-height:min(78vh, 640px);
      aspect-ratio:1.18;
      margin-inline:auto;
    }
    > .pitch-art--compact { display:block; }
    > .pitch-art--tall { display:none; }
    > .playing-field { top:2%; left:3%; width:94%; height:96%; }
    .playing-field [aria-hidden="true"] {pointer-events:none;}
    .sponsor {bottom:14px; left:12px; width:48px;}
  }
  /* Phone: taller art, still centred and aspect-locked. */
  @media(max-width:767px) {
    &.football-container {
      width:min(100%, 420px, calc(70vh * 0.93));
      max-height:min(70vh, 500px);
      aspect-ratio:0.93;
    }
    > .pitch-art--compact { display:none; }
    > .pitch-art--tall { display:block; }
    > .playing-field { top:3%; left:7%; width:86%; height:94%; }
  }
`;
export const Clear = styled.button`
  ${fontUi}; height:36px; box-sizing:border-box; padding:0 12px; font-size:12px; font-weight:600;
  border:1px solid ${({theme})=>theme.border}; background:${({theme})=>theme.card}; color:${({theme})=>theme.text}; border-radius:${({theme})=>theme.controlRadius}; cursor:pointer;
  &:disabled { opacity:.5; cursor:default; }
`;
export const Fixtures = styled.div`
  grid-area:fixtures; min-width:0; container-type:inline-size;
  @media(min-width:1200px) {width:calc(var(--pitch-height,480px) * 1.18);max-width:100%;justify-self:center;}
  @media(min-width:1200px) {
    > section {height:auto;}
    ${CalendarCards} {display:grid;grid-template-columns:repeat(3,minmax(145px,1fr));min-height:0;flex:none;overflow-x:auto;gap:8px;padding:10px !important;align-items:stretch;}
    ${CalendarCards} > button {flex:none;min-width:0;min-height:96px;height:auto;gap:8px;padding:10px;}
    ${ClubName} {font-size:12px;}
    ${ClubName} {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    ${MatchDate} {font-size:11px;overflow-wrap:normal;white-space:nowrap;}
    ${ClubCrest} {width:26px;height:26px;}
    ${StyledTypePill} {font-size:10px;padding:4px 7px;}
  }
`;
export const Players = styled.aside`
  grid-area:players; min-width:0;
  @media(min-width:1200px) {
    height:var(--workspace-body-height,600px);align-self:stretch;
    > section {height:100%;min-height:0;}
  }
  > section { width:100%; }
`;

export const PitchActions = styled.div`
  position:absolute; top:16px; right:16px; z-index:2; display:flex; align-items:center; gap:8px;
  > button { height:36px; border-radius:${({theme})=>theme.controlRadius}; margin:0; }
  > button:first-child { width:36px; padding:7px; }
  > button:first-child svg { width:22px; height:22px; }
  @media(max-width:1199px) {top:12px;right:10px;gap:5px; > button {height:30px; font-size:10px;} > button:first-child {width:30px;padding:5px;} }
`;

export const FormationViewTabs = styled.div`
  display:flex; align-items:center; align-self:center; gap:16px; padding:0 8px; margin-left:auto;
  button { ${fontUi}; background:none; border:0; border-bottom:2px solid transparent; padding:10px 0; color:${({theme})=>theme.textFaint}; font-size:12px; cursor:pointer; white-space:nowrap; }
  button[aria-pressed='true'] { color:${({theme})=>theme.text}; border-bottom-color:${({theme})=>theme.headerAccent}; font-weight:600; }
  @media(min-width:1200px) {flex-wrap:wrap;justify-content:center;gap:8px;padding:0;margin:0;button {font-size:10px;padding:8px 0;}}
  button:hover { color:${({theme})=>theme.text}; }
  @media(max-width:1199px) {width:100%;justify-content:center;gap:24px;margin:0;button {font-size:11px;padding:8px 0;}}
`;
